import { render, staticRenderFns } from "./ProjectMergeItem.vue?vue&type=template&id=57d62dc0&scoped=true&"
import script from "./ProjectMergeItem.vue?vue&type=script&lang=js&"
export * from "./ProjectMergeItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMergeItem.vue?vue&type=style&index=0&id=57d62dc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d62dc0",
  null
  
)

export default component.exports